<template>
  <div :class="groupClass">
    <label :class="lableClass" :for="actualId">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <div :class="inputGroupClass">
        <!--Special Part Starts-->
        <div v-if="$lodash.has($slots, 'prepend')" class="input-group-prepend">
          <slot name="prepend"></slot>
        </div>
        <input
          :id="actualId"
          :autocomplete="autocomplete"
          :class="{ 'is-invalid': form && form.errors.has(errorId) }"
          :disabled="isDisabled"
          :max="max"
          :maxlength="maxlength"
          :min="min"
          :minlength="minlength"
          :name="name"
          :placeholder="placeholder"
          :readonly="isReadonly"
          :required="isRequired"
          :step="step ? step : false"
          :type="isNumber ? 'number' : 'text'"
          :value="value"
          class="form-control"
          @focus="focus($event)"
          @input="update($event.target.value)"
          @keydown="keydown($event)"
        />
        <div v-if="$lodash.has($slots, 'append')" class="input-group-append">
          <slot name="append"></slot>
        </div>
        <!--Special Part Ends-->
      </div>

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    isNumber: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [Number, Boolean, String],
      default: false,
    },
    max: {
      type: [Number, Boolean, String],
      default: false,
    },
    minlength: {
      type: [Number, Boolean, String],
      default: null,
    },
    maxlength: {
      type: [Number, Boolean, String],
      default: null,
    },
    step: {
      default: false,
    },
  },

  methods: {
    update(value) {
      this.$emit("input", value);
    },

    focus(event) {
      this.$emit("focus", event);
    },

    keydown(event) {
      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("keydown", event);
    },
  },
};
</script>
